import React, { useEffect, useState } from 'react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import  {useDispatch, useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
import {getAlerts} from '../../api/APIServices';
import TitleLink from '../../components/TitleLink';
import Alert from './Alert';
import { API_STATUS } from '../../constants';
import {sort} from '../../redux/slices/usersSlice';


function Alerts() {
  const dispatch = useDispatch();

  const {t} = useTranslation('global');
  const {userAlerts:data, userAlertStatus} = useSelector((state)=> state.users );
  const {noteStatus} = useSelector((state)=> state.user );

  const [isAsc, setIsAsc] = useState(true);

  useEffect(() => {
    dispatch(getAlerts({isAlert:true}));
  },[]);

  useEffect(() => {
    if(noteStatus === API_STATUS.SUCCESS){
      dispatch(getAlerts({isAlert:true}));
    }
  },[noteStatus]);

  //SORT DATA
  const sortBy = (sortField='enrollmentDate', isAsc) => {
    setIsAsc(!isAsc);
    let element = 'alerts';
    dispatch(sort({data, sortField, isAsc, element}));
  }

  return (
    <div>

      <div className='full-container'>
        <TitleLink
            boxTitle={t('alerts')}
            enableLink={false}
        />
        <TableContainer  
          sx={{
              // minHeight: 410,
              height:600,
              "& .MuiTableCell-root": {
                border: '1px solid #e3e3e3',
                padding: '6px'
              },
              "&::-webkit-scrollbar-track-piece:start": {
                background: "transparent",
                marginTop: "55px"
              },
              "&::-webkit-scrollbar": {
                width: 6, 
              },
              "&::-webkit-scrollbar-track": {
                  backgroundColor: "white"
              },
              "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#ccc",
                  borderRadius: 2
              },
              "& .MuiInputBase-inputMultiline":{
                fontSize:'12px',
                lineHeight:'18px'
              },
              "& .MuiTypography-root":{
                fontSize:'12px',
                lineHeight:'18px'
              },
          }}>
            <Table size="small" stickyHeader aria-label="sticky table">
                <TableHead 
                sx={{
                    "& th": {
                    backgroundColor: "#def1fc",
                    color: "black",
                    fontWeight:600,
                    },
                    "& th:hover": {
                    backgroundColor: "#c9e8fa",
                    }
                }}>
                  <TableRow>
                      <TableCell colSpan={2} align="center"> {t('name')}</TableCell>
                      <TableCell >&nbsp;</TableCell>
                      <TableCell width="21%" align="center" colSpan={3}>
                          {t('missed_sessions')}
                      </TableCell>
                      <TableCell colSpan={2}>&nbsp;</TableCell> 
                  </TableRow>
                  <TableRow>
                      <TableCell onClick={()=>sortBy('firstName', isAsc)} align="left">
                        {t('first')}
                      </TableCell>
                      <TableCell onClick={()=>sortBy('lastName', isAsc)} align="left">
                        {t('last')}
                        </TableCell>
                      <TableCell align="left">{t('phone_number')}</TableCell>
                      <TableCell width="7%" align="center">{t('education')}</TableCell>
                      <TableCell width="7%" align="center">{t('questionnaire')}</TableCell>
                      <TableCell width="7%" align="center">{t('exercise')}</TableCell>
                      <TableCell>{t('note_history')}</TableCell>
                      <TableCell>{t('action')} </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {(userAlertStatus === API_STATUS.IDEL || userAlertStatus === API_STATUS.PENDING ) &&
                 <h2>{t('loading')}</h2>
                }
                {userAlertStatus === API_STATUS.SUCCESS && 
                data && data.length > 0 && data.map((user, index) => (
                  <Alert key={user.userId} index={index} user={user} />
                ))}
                </TableBody>
            </Table>
          </TableContainer>
        
       
      </div>
    </div>
  )
}

export default Alerts